
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mail_auth",
      function () {
        return require("private-next-pages/mail_auth/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mail_auth"])
      });
    }
  